export { english } from './words/english';

export enum Language {
  'english' = 'english',
}
